/**
 * Shared plumbing for the sensor cards.
 *
 * A sensor arrives as an ordinary selectRow row, so the work is the same every
 * time: parse the text values module_values stores, format numbers for display
 * and work out how stale the reading is.
 *
 * A component mixing this in should set its own staleMinutes, because how long
 * a reading stays fresh depends on how often that device reports.
 */
export default
{
    props:
    {
        // moduleName, temperature, changeDateTime and a values object, exactly
        // what both the house screen and the modules screen already hold
        module:
        {
            type: Object,
            required: true,
        },
    },
    data()
    {
        return {
            staleMinutes: 5,
        };
    },
    computed:
    {
        ageMinutes()
        {
            const me = this;

            if (!me.module.changeDateTime)
            {
                return null;
            }

            // the server stores utc
            const stamp = Date.parse(`${String(me.module.changeDateTime).replace(' ', 'T')}Z`);

            return Number.isNaN(stamp) ? null : (Date.now() - stamp) / 60000;
        },
        stale()
        {
            return (this.ageMinutes === null || this.ageMinutes > this.staleMinutes);
        },
        age()
        {
            const me = this;

            if (me.ageMinutes === null)
            {
                return '';
            }

            return (me.ageMinutes < 1) ? me.$t('NSP_JUST_NOW') : `${Math.round(me.ageMinutes)} min`;
        },
    },
    methods:
    {
        /**
         * module_values stores everything as text, so a raw "0" would read as
         * truthy. Always go through here before comparing or formatting.
         */
        num(key)
        {
            const values = this.module.values || {};
            const parsed = parseFloat(values[key]);

            return Number.isNaN(parsed) ? null : parsed;
        },
        show(value, digits)
        {
            const parsed = parseFloat(value);

            return Number.isNaN(parsed) ? '-' : parsed.toFixed(digits);
        },
    },
};
